import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable()
export class ExcelService {
  constructor() { }
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {   
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  private saveTodayAppointmentAsExcelFile(buffer: any, fileName: string): void { 
    console.log('buffer ', buffer);
    console.log('fileName ', fileName);
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }


  public exportAsPatientExcelFile(json: any[], excelFileName: string): void {
    let index:any =0;
    let subIndex:any=0;
    let dataJsoon = [] as any;
    json.forEach((element) => {
      console.log('print element ', element);
      index ++;
      if(element.email == null){
        element.email = 'N/A';
      }
      if(element.email == ' '){
        element.email = 'N/A';
      }
      if(element.cityName == null){
        element.cityName = 'N/A';
      }
      if(element.gender == null){
        element.gender = 'N/A';
      }
      if(element.mobile == null || element.mobile == ' '){
        element.mobile = 'N/A';
      }
      if(element.patientAge == null){
        element.patientAge = 'N/A';
      }
      if(element.address == null || element.address == ' '){
        element.address = 'N/A';
      }
      if(element.createdDate == null){
        element.createdDate = 'N/A';
      }
      if(element.patientFirstName == null && element.patientLastName){
        element.patientFirstName = 'N/A';
      }
      if(element.referralCode == null){
        element.referralCode = 'N/A';
      }
      if(element.nationalId == null){
        element.nationalId = 'N/A';
      }

      
      dataJsoon.push(
        { 
          sno:index,
          PatientName: element.patientFirstName + '' + element.patientLastName,
          DOB: element.patientDOB,
          Age: element.patientAge,
          City:element.cityName,
          ReferralCode:element.referralCode,
          mobile:element.mobile,
          email:element.email,
          address:element.address,
          nationalId:element.nationalId,
          createdDate:element.createdDate
        })
      if (element.childList.length > 0) {
        subIndex=0;     
        element.childList.forEach((subelement) => {


          if(subelement.email == null){
            subelement.email = 'N/A';
          }
          if(subelement.email == ' '){
            subelement.email = 'N/A';
          }
          if(subelement.cityName == null){
            subelement.cityName = 'N/A';
          }
          if(subelement.gender == null){
            subelement.gender = 'N/A';
          }
          if(subelement.mobile == null || subelement.mobile == ' '){
            subelement.mobile = 'N/A';
          }
          if(subelement.patientAge == null){
            subelement.patientAge = 'N/A';
          }
          if(subelement.address == null || subelement.address == ' '){
            subelement.address = 'N/A';
          }
          if(subelement.createdDate == null){
            subelement.createdDate = 'N/A';
          }
          if(subelement.patientFirstName == null && subelement.patientLastName){
            subelement.patientFirstName = 'N/A';
          }
          if(subelement.referralCode == null){
            subelement.referralCode = 'N/A';
          }
          if(subelement.nationalId == null){
            subelement.nationalId = 'N/A';
          } 




          subIndex++;
          dataJsoon.push(
            {
              sno: parseFloat(index+'.'+subIndex),
              PatientName: subelement.patientFirstName + '' + subelement.patientLastName,
              DOB: subelement.patientDOB,
              Age: subelement.patientAge,
              City:subelement.cityName,
              ReferralCode:subelement.referralCode,
              mobile:subelement.mobile,
              email:subelement.email,
              address:subelement.address,
              nationalId:subelement.nationalId,
              createdDate:subelement.createdDate              

            })
           
        })
      }

  })
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataJsoon); 
  const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'],};  
  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


 
}


// WEBPACK FOOTER //
// ./src/app/services/excel.service.ts